module.exports = __webpack_public_path__ + "like.1abb88fd.png";